<template>
  <div id="home" class="yiyuan">
    <router-view />
    <el-carousel :interval="5000" arrow="never">
      <!--<el-carousel-item>-->
        <!--<div class="background"></div>-->
      <!--</el-carousel-item>-->
      <el-carousel-item>
        <div class="background1">
          <div class="box">
            
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import store from '../vuex'

export default {
  name: 'home',
  methods: {
    open () {
      store.commit('changeShuomingStatus')
    }
  }
}
</script>

<style lang="scss">
  .yiyuan {
    .el-carousel {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      .el-carousel__container {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>

<style scoped lang="scss">
#home {
  width: 100%;
  height: 100%;
  position: relative;

  .background, .background1 {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #57AEC9;
    background-image: url(../assets/img/home_bg.jpg);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .background1 {
    background-image: url(../assets/img/home_bg.jpg);
  }

  .box {
    width: 50%;
    margin-left: 40%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    position: relative;

    .font {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 9rem;
      height: 7.5rem;
      p {
        font-size: 0.48rem;
        letter-spacing: 0.04rem;
        color: #ffffff;
        float: right;
        text-shadow: $blue .02rem .02rem 0rem;
        line-height: 1rem;
      }
      div {
        position: absolute;
        right: 0;
        color: #fff;
        font-size: .2rem;
        margin-top: 1rem;
        width: 1.8rem;
        height: .5rem;
        border: 1px solid #fff;
        line-height: .5rem;
        box-sizing: border-box;
        border-radius: .5rem;
        cursor: pointer;
        text-shadow: $blue .02rem .02rem 0rem;
        i {
          display: inline-block;
          vertical-align: top;
          border-radius: 50%;
          width: .34rem;
          height: .34rem;
          background: #fff;
          margin: .08rem;
          text-shadow: $blue .02rem .02rem 0rem;
          b {
            display: inline-block;
            width: .11rem;
            height: .11rem;
            border-left: 2px solid #000;
            border-top: 2px solid #000;
            transform: rotate(-45deg);
            margin: .11rem .13rem;
          }
        }
        span {
          display: inline-block;
          width: calc(100% - .7rem);
          text-align: center;
          text-shadow: $blue .02rem .02rem 0rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue